import { Route, Routes } from "react-router-dom";
import { NotificationListing } from "features/notifications/NotificationsListing";

export const Notifications: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<NotificationListing />} />
    </Routes>
  );
};